import { useState } from 'react';
import { areaLabel, type EsnafItem } from './esnafData';

export default function EsnafCard({ item }: { item: EsnafItem }) {
  // Logo yuklenemezse (silinmis dosya vb.) dairede kesik alt metni yerine bas harfler
  const [logoFailed, setLogoFailed] = useState(false);
  const initials = item.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toLocaleUpperCase('tr-TR');
  const area = areaLabel(item);

  return (
    <div className="flex items-center gap-3 min-w-0 bg-white rounded-xl border border-gray-100 shadow-sm p-3" data-testid="esnaf-card">
      {item.logo && !logoFailed ? (
        <img
          src={item.logo}
          alt={`${item.name} logosu`}
          loading="lazy"
          onError={() => setLogoFailed(true)}
          className="w-12 h-12 rounded-full object-cover bg-gray-100 shrink-0"
        />
      ) : (
        <div
          aria-hidden="true"
          className="w-12 h-12 rounded-full bg-[#e77e23]/10 text-[#e77e23] font-bold flex items-center justify-center shrink-0"
        >
          {initials}
        </div>
      )}
      <div className="min-w-0">
        <p className="font-semibold text-sm text-[#111827] truncate">{item.name}</p>
        {area && (
          <p className="text-xs text-gray-500 truncate flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {area}
          </p>
        )}
      </div>
    </div>
  );
}
